import { render } from "./Table.vue?vue&type=template&id=64ef8970"
import script from "./Table.vue?vue&type=script&lang=ts"
export * from "./Table.vue?vue&type=script&lang=ts"

import "./Table.vue?vue&type=style&index=0&id=64ef8970&lang=less"
script.render = render

export default script